import { memo } from 'react';
import { Box } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectStatus } from '../../state';
import StatusCircularProgress from '../../components/StatusCircularProgress/StatusCircularProgress';
import StatusResetDisclaimer from '../../components/StatusResetDisclaimer/StatusResetDisclaimer';
import StatusPerkList from '../../components/perks/StatusPerkList';
import StatusProgress from '../../components/StatusProgress';

function StatusProgressInfo() {
  const status = useSelector(selectStatus);

  if (!status) {
    return null;
  }

  const {
    playerStatus,
    nextPlayerStatus,
    accumulatedLoyaltyPoints,
    totalLoyaltyPoints,
    claimedBoxesCount,
    promotionNumberOfBoxes,
    keepStatusNumberOfBoxes,
    nextStatusRewardAmount,
  } = status;

  return (
    <Box alignItems="center" gap="space-400">
      <StatusCircularProgress
        playerStatus={playerStatus}
        currentPoints={accumulatedLoyaltyPoints}
        totalPoints={totalLoyaltyPoints}
      />

      <StatusProgress
        currentStatus={playerStatus}
        nextStatus={nextPlayerStatus}
        claimedBoxesCount={claimedBoxesCount}
        promotionNumberOfBoxes={promotionNumberOfBoxes}
        keepStatusNumberOfBoxes={keepStatusNumberOfBoxes}
        nextStatusRewardAmount={nextStatusRewardAmount}
        totalLoyaltyPoints={totalLoyaltyPoints}
      />

      <StatusPerkList
        currentStatus={playerStatus}
        nextStatus={nextPlayerStatus}
      />

      <StatusResetDisclaimer />
    </Box>
  );
}

export default memo(StatusProgressInfo);
